export default "__VITE_ASSET__eWjoNAiQ__"